import { useNavigate, useLocation } from "react-router-dom";
import { LayoutDashboard, Calendar, Star, Settings, BookOpen, Home, Ticket, LogOut, FileEdit } from "lucide-react";
import { Button } from "@/components/ui/button";
import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    const token = localStorage.getItem("adminToken");
    if (token) {
      try {
        await axios.post(`${API}/admin/logout?token=${token}`);
      } catch (error) {
        console.error("Logout error:", error);
      }
    }
    localStorage.removeItem("adminToken");
    toast.success("Logged out successfully");
    navigate("/admin/login");
  };

  const menuItems = [
    { icon: LayoutDashboard, label: "Dashboard", path: "/admin" },
    { icon: Home, label: "Properties", path: "/admin/properties" },
    { icon: BookOpen, label: "Bookings", path: "/admin/bookings" },
    { icon: Ticket, label: "Discount Codes", path: "/admin/discount-codes" },
    { icon: Calendar, label: "Cleaning", path: "/admin/cleaning" },
    { icon: Star, label: "Reviews", path: "/admin/reviews" },
    { icon: FileEdit, label: "Site Content", path: "/admin/content" },
    { icon: Settings, label: "Settings", path: "/admin/settings" },
  ];

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Sidebar */}
      <aside className="fixed left-0 top-0 h-full w-64 bg-white border-r border-border p-6 flex flex-col" data-testid="admin-sidebar">
        <div className="mb-8">
          <h2 className="text-2xl font-heading font-bold text-primary mb-2">
            KSpace Admin
          </h2>
          <Button 
            variant="ghost" 
            size="sm" 
            className="text-slate-600"
            onClick={() => navigate('/')}
            data-testid="back-to-site-button"
          >
            <Home className="w-4 h-4 mr-2" />
            Back to Site
          </Button>
        </div>

        <nav className="space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                  isActive 
                    ? 'bg-primary text-white' 
                    : 'text-slate-700 hover:bg-secondary'
                }`}
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                <Icon className="w-5 h-5" />
                <span className="font-medium">{item.label}</span>
              </button>
            );
          })}
        </nav>

        <div className="absolute bottom-6 left-6 right-6">
          <Button
            variant="outline"
            className="w-full justify-start text-slate-700 hover:text-destructive hover:border-destructive"
            onClick={handleLogout}
            data-testid="logout-button"
          >
            <LogOut className="w-5 h-5 mr-3" />
            <span className="font-medium">Logout</span>
          </Button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="ml-64 p-8">
        <div className="max-w-7xl mx-auto">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;